<template>
  <div class="innerItem">
    <p class="innerTitle setLabel">{{locale.parking_information}}</p>
    <div class="mb15">
      <div class="checkbox mb5">
        <input type="checkbox" id="parking_active" v-model="parking.active">
        <label for="parking_active" class="label">{{ locale.activate }}</label>
      </div>
      <p class="sysMessage">{{ locale.message_required_external_system }}</p>
    </div>
    <div v-if="parking.active">
      <div class="mb15">
        <div class="label colorGrey">{{locale.display_information}}</div>
        <div class="mb5">
          <div class="checkbox">
            <input type="checkbox" id="parking_display_parking_area" v-model="parking.display.area">
            <label for="parking_display_parking_area" class="label">{{locale.parking_area}}</label>
          </div>
        </div>
        <div class="mb5">
          <div class="checkbox">
            <input type="checkbox" id="parking_display_entrance_time" v-model="parking.display.entrance">
            <label for="parking_display_entrance_time" class="label">{{locale.entrance_time}}</label>
          </div>
        </div>
        <div class="mb5">
          <div class="checkbox">
            <input type="checkbox" id="parking_display_depature_time" v-model="parking.display.depature">
            <label for="parking_display_depature_time" class="label">{{locale.depature_time}}</label>
          </div>
        </div>
      </div>
      <div class="mb15">
        <div class="checkbox onoff">
          <input type="checkbox" id="parking_regist" v-model="parking.regist">
          <label for="parking_regist" class="label">{{parking.regist ? locale.regist_possible : locale.regist_not_possible}}</label>
        </div>
      </div>
      <div>
        <div class="label colorGrey">{{locale.parking_car_limit}}</div>
        <div class="mt5 mb15"><input type="text" class="input sizeS" v-model="parking.carLimit" @input="numberOnly($event, 'carLimit')"></div>
      </div>
        <div class="label mb10 setLabel">{{ locale.feature_permission_settings }}</div>
        <div class="mb15">
          <span class="checkbox radio mr20">
            <input type="radio" name="parking_available_type" id="parking_available_ota" v-model="parking.availableType" value="checkIn">
            <label for="parking_available_ota">{{ locale.staying_guest }}</label>
          </span>
          <span class="checkbox radio">
            <input type="radio" name="parking_available_type" id="parking_available_rid" v-model="parking.availableType" value="preArrive">
            <label for="parking_available_rid">{{ locale.planning_stay_guest }}</label>
          </span>
        </div>
        
        <div v-if="parking.availableType === 'checkIn'" class="mb15">
          <div class="typeItem">
            <div class="checkbox">
              <input type="checkbox" id="parking_ota_edit" v-model="parking.setting.checkIn.updateParking">
              <label for="parking_ota_edit">{{ locale.modify_parking_information }}</label>
            </div>
            <div class="checkbox">
              <input type="checkbox" id="parking_ota_delete" v-model="parking.setting.checkIn.cancelParking">
              <label for="parking_ota_delete">{{ locale.cancel_parking_registration }}</label>
            </div>
          </div>
        </div>
        
        <div v-if="parking.availableType === 'preArrive'" class="mb15">
          <div class="typeItem">
            <div class="checkbox">
              <input type="checkbox" id="parking_rid_edit" v-model="parking.setting.preArrive.updateParking">
              <label for="parking_rid_edit">{{ locale.modify_parking_information }}</label>
            </div>
            <div class="checkbox">
              <input type="checkbox" id="parking_rid_delete" v-model="parking.setting.preArrive.cancelParking">
              <label for="parking_rid_delete">{{ locale.cancel_parking_registration }}</label>
            </div>
          </div>
        </div>
    </div>  
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'Parking',
  props: [
    'locale',
    'parking'
  ],
  computed: {
  },
  mounted () {
  },
  created() {
    if (!this.parking.availableType) {
      this.$set(this.parking, 'availableType', 'checkIn');
    }
    if (!this.parking.setting) {
      this.$set(this.parking, 'setting', {
        checkIn: { updateParking: false, cancelParking: false },
        preArrive: { updateParking: false, cancelParking: false }
      });
    } else {
      if (!this.parking.setting.checkIn) this.$set(this.parking.setting, 'checkIn', { updateParking: false, cancelParking: false });
      if (!this.parking.setting.preArrive) this.$set(this.parking.setting, 'preArrive', { updateParking: false, cancelParking: false });
    }
  },
  data () {
    return {
    }
  },
  methods: {
    numberOnly (e, target) {
      this.parking[target] = Math.floor(regExp.numberOnly(e.target.value))
    }
  }
}
</script>
<style lang="scss" scoped>
.typeItem {
  display: flex;
  align-items: center;
  .type {
    flex: 0 0 100px;
    font-size: 1.4rem;
    color: #424242;
  }
  .checkbox {
    margin-right: 20px;
  }
}
</style>
